import { GetStaticProps, NextPage } from 'next'
import dynamic from 'next/dynamic'
import React from 'react'
import { Footer } from 'src/components/Footer/Footer'
// import { Breadcrumb } from 'src/components/global/Breadcrumb'
import MainContainer from 'src/components/global/MainContainer/MainContainer'
import { ThemeOnly } from 'src/components/global/ThemeOnly'
import SkeletonLoading from 'src/components/SkeletonLoading/SkeletonLoading'
import { LTH_SOLUTION_MENU } from 'src/constants/constants'
import { Meta } from 'src/layout/Meta'
import { Main } from 'src/templates/Main'

const Breadcrumb = dynamic(() => import('src/components/global/Breadcrumb').then((mod) => mod.Breadcrumb), {
  ssr: false,
  loading: () => <SkeletonLoading className="bg-navy" />,
})

type Props = {
  slug: string
  hspDetails?: any
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const LthSolution: NextPage<Props> = ({ slug, hspDetails }: Props) => {
  const data = LTH_SOLUTION_MENU.find((item) => item.slg === '/lth-solution/' + slug)

  const url = data?.externalLink || ''
  const title = data?.title || ''
  const description =
    'Legaltech Hub is founded by a team of legal technology enthusiasts who in their career have acted as buyers, vendors, investors and advisors to buyers and vendors. With more than 50 years of collective experience in legaltech, the team is well placed to help bring transparency to the Legal Tech Market.\
  By listing all relevant legal tech solutions, Legal Tech Hub allows buyers of legal tech to see the woods from the trees, vendors to showcase their solutions and investors to understand the market. Industry insights complement the directory.'

  //const proxyUrl = `/api/proxy?url=${encodeURIComponent(url)}`

  const meta = (
    <Meta
      title={title}
      description={description}
      url="/lth-solution/"
      keywords={['Nicola (Nikki) Shaver - CEO, Jeroen Plink - COO, Chris Ford - Advisor, Sam Whitman - Advisor']}
    />
  )

  return (
    <Main meta={meta}>
      <MainContainer id="mainContainer">
        <div className="flex flex-col bg-clouds">
          <Breadcrumb subject={`LTH SOLUTIONS`} subjectRoute={'/'} subtitle={title} />
          {/* {aboutInfo && <AboutHeader about={aboutInfo} />} */}
        </div>
        <hr />

        <div style={{ width: '100%', height: data?.height || '600px' }}>
          <iframe
            src={url}
            width="100%"
            style={{ border: 'none', height: data?.height || '100%' }}
            loading="lazy"
            title={title}
          />
        </div>

        {/* <div className="w-full items-center justify-between sm:mb-[3rem]">
          <div className="flex flex-col pl-[1.25rem] pr-[1.25rem] !max-w-[1100px] w-full py-2 m-auto">
            <h2 className="pt-[0.1rem] pb-[0.125rem] md:text-[24px] text-[1.5rem] font-bold font-secondary text-[#222222] mb-[30px] md:mt-[20px] mt-[3rem] sm:mb-[3rem]">
              Testing
            </h2>

          </div>
        </div> */}

        {/* <div id="contact-section" className="flex flex-col bg-clouds">
          <div className="w-full items-center justify-between">
            <div className="flex flex-col pl-[1.25rem] pr-[1.25rem] !max-w-[1100px] w-full py-2 m-auto">
              <div className="pt-[0.1rem] pb-[0.125rem] text-[1.875rem] font-bold font-secondary text-[#222222] mt-[3rem]">
                {hspDetails?.title}
              </div>

              <div className="flex flex-row w-full">
                <div className="flex flex-col w-full md:w-1/2">
                  <div id="my-hubspot-form"></div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <ThemeOnly theme="legaltech">
          <Footer />
        </ThemeOnly>
      </MainContainer>
    </Main>
  )
}

export default LthSolution

export const getStaticProps: GetStaticProps<any> = async ({ params }) => {
  if (!params?.slug) return { revalidate: 60, notFound: true }

  const slug = params.slug
  // const data = LTH_SOLUTION_MENU.find((item) => item?.containerid === slug) || null
  // if (!data) return { notFound: true }

  const res = {
    props: {
      slug: slug,
      //hspDetails: data,
    },
    revalidate: 60,
  }
  return res
}

export async function getStaticPaths() {
  const paths = LTH_SOLUTION_MENU.filter((item) => !!item).map((item) => {
    const slug = item?.containerid
    return {
      params: { slug },
    }
  })
  return {
    paths,
    fallback: 'blocking',
  }
}
